module.exports = __webpack_public_path__ + "img/gold_big_icon.087eb1e4.png";